import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CityArgenteuilPage() {
  const data = citiesData.find((c) => c.slug === "argenteuil")!;
  return <CityPage data={data} />;
}
